<template>
    
      <b-card>
        <b-row>
          <div style="position:absolute; top:10px; right:25px;">
            <span style="display: inline-block" class="mr-2">
              <b-form-checkbox-group
                v-model="selectedView"
                :options="visibleOptions"
              >
              </b-form-checkbox-group>
            </span>
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="salesAndExpenseFilters.salesRep" @change="onGetSalesAndExpense" class="mb-2">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="salesAndExpenseSelectedDateRange" @change="onDateRangeChange" class="mb-2 mr-2">
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select> 
            </span>
          </div>
          <b-modal size="sm" title="Custom Date for Sales And Expense" id="custom-date-sales-and-expense" 
            @ok="onCustomSet" @cancel="$bvModal.hide('custom-date-sales-and-expense')" no-close-on-backdrop>
            <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
            <b-form-group label="From" class="mb-4 mr-2" >
              <date-picker v-model="salesAndExpenseFilters.dateFrom" :config="datePickerOptions" size="sm" />
            </b-form-group>
            <b-form-group label="To" class="mb-4">
              <date-picker v-model="salesAndExpenseFilters.dateTo" :config="datePickerOptions" size="sm" />
            </b-form-group>
            </div>          
          </b-modal> 
        </b-row>
        <br/>
        <div>
          <apex-chart chartType="bar" :chartOptions="chartOptions" :chartSeries="visibleSeries" />
        </div>
      </b-card>  
</template>

<script>
  import ApexChart from './../extensions/ApexChart'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import { date } from '@/shared/filters';

  export default {
    components: {
      ApexChart
    },
    data () {
      return {
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        salesBySalesRep: [],
        chartOptions: {},
        chartSeries: [],
        visibleOptions: ['Sales', 'Expenses'],
        selectedView: ['Sales', 'Expenses']
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapGetters('dashboard', ['salesAndExpenseSelectedDateRange', 'salesAndExpenseFilters']),
      ...mapState('salesReps', ['salesReps']),
      visibleSeries() {
        let showSeries = [];
        for (let i = 0; i < this.chartSeries.length; i++) {
          if (this.chartSeries[i].name == 'Total Sales' && this.selectedView.indexOf('Sales') !== -1) {
            showSeries.push(this.chartSeries[i]);
          }
          if (this.chartSeries[i].name == 'Total Expense' && this.selectedView.indexOf('Expenses') !== -1) {
            showSeries.push(this.chartSeries[i]);
          }
        }

        return showSeries;
      }
    }, 
    methods: {
      ...mapActions('dashboard', ['getSalesAndExpense']),
      ...mapMutations('dashboard', ['setItem']),
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.salesAndExpenseFilters.dateFrom = null;
          this.salesAndExpenseFilters.dateTo= null;
          this.$bvModal.show('custom-date-sales-and-expense');
        } else {
          
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.setDefaults(dateFrom, dateTo);
          this.salesAndExpenseFilters.dateFrom = dateFrom;
          this.salesAndExpenseFilters.dateTo= dateTo;
          this.onGetSalesAndExpense();
        }

        this.setItem({ resource: 'salesAndExpenseSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.salesAndExpenseFilters.dateFrom && this.salesAndExpenseFilters.dateTo) {
          this.setDefaults(this.salesAndExpenseFilters.dateFrom, this.salesAndExpenseFilters.dateTo);
          this.onGetSalesAndExpense();
        }
        this.$bvModal.hide('custom-date-sales-and-expense');
      },
      async onGetSalesAndExpense() {
        this.isLoadingWidget = true;

        await this.getSalesAndExpense(this.salesAndExpenseFilters).then((res) => { 
          this.chartOptions = {
              ...this.chartOptions,
            noData: {
                text: (res.length > 0) ? '' : 'No available data'
            },
            xaxis: {
              categories: res.map(x => date(x.date))
            }
          };

          this.chartSeries = [
            {
                name: 'Total Sales',
                data: res.map(x => x.totalSales),
                color: '#6bad10'
            },
            {
                name: 'Total Expense',
                data: res.map(x => x.totalExpense),
                color: '#d0021b'
            }
          ]
          this.isLoadingWidget = false;
        });
      },
      setDefaults(from = null, to = null) {
          this.chartOptions = { 
            chart: {
                id: 'sales-and-expense-bar',
                type: 'bar',
                height: 300
            },
            title: {
                text: 'Sales And Expense'
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    // endingShape: 'rounded',
                    borderRadius: 10,
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },

                }
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return "$ " + val
                }
              }
            },
            noData: {
                text: 'Fetching data...'
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return "$" + val;
              },
              offsetY: -20,
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              }
            },
            stroke: {
              show: true,
              width: 5,
              colors: ['transparent']
            },
          };
          this.chartSeries = [];
      },
      commafy(num, currency = "", decimal = 2) {
        try {
          if (num != null) {
            if (currency != "") {
              num = Number(num).toFixed(decimal);
            }
            var str = num.toString().split('.');
            if (str[0].length >= 3) {
              str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
            if (str[1]) {
              if (str[1].length < decimal) {
                while (str[1].length < decimal) { str[1] = str[1] + "0"; }
              } else if (str[1].length > decimal) {
                str[1] = str[1].substring(0, decimal)
              }
            }
            return currency + str.join('.');
          }
        } catch {
          return num;
        }
      },
    },
    mounted () {
      const { dateFrom, dateTo } = getDatesFromRangeString(this.salesAndExpenseSelectedDateRange);
      this.setDefaults(dateFrom, dateTo);
      this.salesAndExpenseFilters.dateFrom = dateFrom;
      this.salesAndExpenseFilters.dateTo = dateTo;
      this.onGetSalesAndExpense();   
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>